export default "__VITE_ASSET__DUpVu48z__"